import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {CheckboxQuestion, DatePicker, InlineDiv, RadioButtonQuestion, TextInput,} from '../../../components'
import FormPageSection from "./FormPageSection";

const Container = styled.div`  
`;

const Level1Form = ({onChange, form}) => (
  <Container>
    <FormPageSection small title="Part A and B">
      <ol>
        <li>
          <RadioButtonQuestion
            id="a1"
            items={RadioButtonQuestion.YesNo}
            value={form['a1'].value}
            onChange={onChange('a1')}
            error={!form['a1'].hasError ? null : true}
            question="Pre-admission screen Part A and/or B completed?"
            disabled={form['a1'].disabled}
          />
        </li>
        <li>
          <RadioButtonQuestion
            id="a2"
            items={RadioButtonQuestion.YesNo}
            value={form['a2'].value}
            // disabled={form['a1'] === 'no'}
            error={!form['a2'].hasError ? null : true}
            question="If yes to above, was it completed prior to nursing facility admission?"
            onChange={onChange('a2')}
            disabled={form['a2'].disabled}
          >
            <InlineDiv>
              <DatePicker
                value={form['a2date'].value}
                onChange={onChange('a2date')}
                error={!form['a2date'].hasError ? null : true}
              />
            </InlineDiv>
          </RadioButtonQuestion>
        </li>
        <li>
          <RadioButtonQuestion
            id="a3"
            items={RadioButtonQuestion.YesNo}
            value={form['a3'].value}
            error={!form['a3'].hasError ? null : true}
            question="Is Part A and/or B information validated within the resident's medical record?"
            onChange={onChange('a3')}
            disabled={form['a3'].disabled}
          />
        </li>
      </ol>
      <CheckboxQuestion
        inline
        selected={form['a4'].value}
        question="Indicate the presence of"
        values={['SMI', 'ID', 'DD']}
        onChange={onChange('a4')}
        error={!form['a4'].hasError ? null : true}
        disabled={form['a4'].disabled}
      />
      <TextInput
        title="Diagnosis"
        value={form['a5'].value}
        onChange={onChange('a5')}
        disabled={form['a5'].disabled}
      />
      <TextInput
        title="Medications"
        value={form['a6'].value}
        onChange={onChange('a6')}
        disabled={form['a6'].disabled}
      />
    </FormPageSection>
    <FormPageSection small title="Part C - Exemptions">
      <p>
        If the provider has answered "no" to all questions in Part A and Part B of the DHS 1178 Form this section is N/A. Proceed 
        to Resident Review section of the worksheet. If the provider has answered "yes" to any question in Part A or Part B of 
        the DHS 1178 Form, and no exemptions are indicated, this section is N/A. Proceed to Level Il Evaluation section of the 
        worksheet. 
      </p>
      <ol start={4}>
        <li>
          {/*<SelectBoxQuestion*/}
          {/*selected={form['c1'] || ''}*/}
          {/*items={[1, 2, 3, 4, 5, 6, 7, 8, 9, 10]}*/}
          {/*placeholder="<Select Exemption>"*/}
          {/*onChange={onChange('c1')}*/}
          {/*renderItem={x => <option key={x} value={x}>{x}</option>}*/}
          {/*question="Indicate the number of the exemption the provider selected"*/}
          {/*/>*/}
          <RadioButtonQuestion
            id="c1"
            value={form['c1'].value}
            onChange={onChange('c1')}
            question="Indicate the number of the exemption the provider selected"
            items={[1, 2, 3, 4, 5, 6, 'N/A'].map(x => x.toString(10)).map(x => RadioButtonQuestion.createItem(x, x))}
            error={!form['c1'].hasError ? null : true}
            disabled={form['c1'].disabled}
          />
        </li>
        <li>
          <RadioButtonQuestion
            id="c2"
            value={form['c2'].value}
            onChange={onChange('c2')}
            disabled={form['c2'].disabled}
            items={RadioButtonQuestion.YesNoNotApplicable}
            question="Has the Recipient been discharged within exemption timeframe?"
            error={!form['c2'].hasError ? null : true}
          >
            <InlineDiv>
              <DatePicker
                value={form['c2date'].value}
                onChange={onChange('c2date')}
                disabled={form['c2date'].disabled}
              />
            </InlineDiv>
          </RadioButtonQuestion>
        </li>
        <li>
          <RadioButtonQuestion
            id="c3"
            items={RadioButtonQuestion.YesNoNotApplicable}
            value={form['c3'].value}
            disabled={form['c3'].disabled}
            question="Has the Recipient expired within exemption timeframe?"
            onChange={onChange('c3')}
            error={!form['c3'].hasError ? null : true}
          >
            <InlineDiv>
              <DatePicker
                value={form['c3date'].value}
                onChange={onChange('c3date')}
                disabled={form['c3date'].disabled}
              />
            </InlineDiv>
          </RadioButtonQuestion>
        </li>
        <li>
          <RadioButtonQuestion
            id="c4"
            items={RadioButtonQuestion.YesNoNotApplicable}
            value={form['c4'].value || ''}
            disabled={form['c4'].disabled}
            question="Is Part C information validated within the resident's medical record?"
            onChange={onChange('c4')}
            error={!form['c4'].hasError ? null : true}
          />
        </li>
      </ol>
    </FormPageSection>

  </Container>
)

Level1Form.propTypes = {
  form: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default Level1Form;



// WEBPACK FOOTER //
// ./src/modules/record/components/Level1Form.js